import React from 'react';

interface PrintProps {
  fill?: string;
  width?: number;
}

export function Print({ fill = '#343434', width = 16.7143056 }: PrintProps) {
  const aspectRatio = 15.4285898 / 16.7143056;
  const height = width * aspectRatio;

  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 16.7143056 15.4285898"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        className="print-icon-group"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g className="print-icon-article" fill={fill} fillRule="nonzero">
          <path
            className="print-icon-shape"
            d="M3.85714746,14.142874 L3.85714746,11.5714424 L12.8571582,11.5714424 L12.8571582,14.142874 L3.85714746,14.142874 Z M3.85714746,7.71429491 L3.85714746,1.28571582 L10.2857265,1.28571582 L10.2857265,2.89286059 C10.2857265,3.4252273 10.7176467,3.85714746 11.2500134,3.85714746 L12.8571582,3.85714746 L12.8571582,7.71429491 L3.85714746,7.71429491 Z M15.4285898,8.35715282 C15.4285898,8.70871574 15.1372948,9.00001073 14.7857319,9.00001073 C14.434169,9.00001073 14.142874,8.70871574 14.142874,8.35715282 C14.142874,8.0055899 14.434169,7.71429491 14.7857319,7.71429491 C15.1372948,7.71429491 15.4285898,8.0055899 15.4285898,8.35715282 Z M16.7143056,8.35715282 C16.7143056,7.30246406 15.8404207,6.42857909 14.7857319,6.42857909 L14.142874,6.42857909 L14.142874,3.85714746 C14.142874,3.32478075 13.8415344,2.59152095 13.4598375,2.20982406 L11.9330499,0.683036529 C11.5513531,0.301339645 10.8180933,0 10.2857265,0 L3.5357185,0 C3.00335179,0 2.57143164,0.431920158 2.57143164,0.964286864 L2.57143164,6.42857909 L1.92857373,6.42857909 C0.87388497,6.42857909 0,7.30246406 0,8.35715282 L0,12.5357292 C0,12.7064884 0.150669822,12.8571582 0.321428955,12.8571582 L2.57143164,12.8571582 L2.57143164,14.464303 C2.57143164,14.9966697 3.00335179,15.4285898 3.5357185,15.4285898 L13.1785871,15.4285898 C13.7109538,15.4285898 14.142874,14.9966697 14.142874,14.464303 L14.142874,12.8571582 L16.3928767,12.8571582 C16.5636358,12.8571582 16.7143056,12.7064884 16.7143056,12.5357292 L16.7143056,8.35715282 Z"
          ></path>
        </g>
      </g>
    </svg>
  );
}
